module.exports = "/src/views/player/help/images/barb1.png";